import React from 'react';
import ServiceIcon from './ServiceIcon';
import {SERVICES} from '../siteConfig';

function ServicesGrid({featuredOnly}) {
  const list=featuredOnly ? SERVICES.filter((s)=> s.featured) : SERVICES;
  return (
    <div className="tab-grid">
      {list.map((s)=> (
        <article className="tab-card" key={s.id} id={featuredOnly ? undefined : s.id}>
          <span className="glance-icon"><ServiceIcon name={s.icon} /></span>
          <h3>{s.title}</h3>
          <p>{s.text}</p>
        </article>
      ))}
    </div>
  );
}

export default ServicesGrid;
